import React, { useState } from 'react';
import '../../styles/AllergensList.scss';
import * as Icons from '../../assets/images/allergens/AllergenIcons';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const allergens = [
    { name: 'Glutine', icon: <Icons.GlutenIcon /> }, 
    { name: 'Uova', icon:  <Icons.EggIcon /> }, 
    { name: 'Arachidi', icon:  <Icons.PeanutsIcon /> }, 
    { name: 'Lattosio', icon:  <Icons.MilkIcon />}, 
    { name: 'Crostacei', icon:  <Icons.CrustaceanIcon /> }, 
    { name: 'Pesce', icon:  <Icons.FishIcon /> }, 
    { name: 'Soia', icon: <Icons.SoyIcon /> }, 
    { name: 'Frutta a guscio', icon:  <Icons.NutsIcon /> }, 
    { name: 'Sedano', icon:  <Icons.CeleryIcon /> }, 
    { name: 'Senape', icon:  <Icons.MustardIcon /> }, 
    { name: 'Semi di sesamo', icon: <Icons.SesameIcon /> }, 
    { name: 'Anidride solforosa', icon: <Icons.SulfitesIcon /> }, 
    { name: 'Lupini', icon: <Icons.LupinsIcon /> }, 
    { name: 'Molluschi', icon: <Icons.ShellfishIcon /> }
];

const AllergensList = ({ selectedAllergens, onAllergenToggle }) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="allergens-list-container">
            <div className="allergens-header" onClick={toggleOpen}>
                <h4>Filtra per allergeni</h4>
                <p>Escludi alimenti con determinati allergeni cliccando sulle icone.</p>
                <ExpandMoreIcon className={`toggle-icon ${isOpen ? 'open' : ''}`} />
            </div>
            <div className={`allergens-list ${isOpen ? 'expanded' : ''}`}>
                {allergens.map((allergen, index) => (
                    <div 
                        key={index} 
                        className={`allergen-item ${selectedAllergens.includes(allergen.name) ? 'selected' : ''}`} 
                        onClick={() => onAllergenToggle(allergen.name)}
                    >
                        <div className="allergen-icon">
                            {allergen.icon}
                        </div>
                        <p>{allergen.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AllergensList;
